import React from 'react'
import { Footer, menuLogo, globalRibbon } from 'cvs-shared'
import Home from './home'
import Prepare from './Prepare'
import Learn from './Learn'
import WrapUp from './Wrap-Up'
import Challenge from './Challenge'
import Certificate from './certificate'
import backgroundImage from '../assets/images/background.svg'
// import progressBarImage from '../assets/images/global-ribbon.svg';

export default {
  pages: [Home, Prepare, Learn, WrapUp, Challenge, Certificate],
  metaData: {
    Footer,
    backgroundImages: {
      backgroundImage,
    },
    menu: {
      logo: <img src={menuLogo} alt="menu logo" />,
      title: 'Vaping Risks Revealed',
      subTitle: '',
    },
    progressBarImage: globalRibbon,
  },
}



// WEBPACK FOOTER //
// ./src/data/index.js